<template>
  <ListPage tabName="owned"></ListPage>
</template>
<script>
import ListPage from "../Component/ListPage";
export default {
  components: {
    ListPage
  }
};
</script>
